const analyticsMap = {
    A1: {
        Fire: 'onScroll',
        Category: 'navigation_scroll',
        Action: 'reached_causes',
        Label: '<url>',
        Output: 'ga(\'send\',  \'navigation_scroll\', \'reached_causes\', \'<url>\');',
    },
    A2: {
        Fire: 'onScroll',
        Category: 'navigation_scroll',
        Action: 'reached_organizations',
        Label: '<url>',
        Output: 'ga(\'send\',  \'navigation_scroll\', \'reached_organizations\', \'<url>\');',
    },
    A3: {
        Fire: 'onScroll',
        Category: 'navigation_scroll',
        Action: 'reached_csr',
        Label: '<url>',
        Output: 'ga(\'send\',  \'navigation_scroll\', \'reached_csr\', \'<url>\');',
    },
    A4: {
        Fire: 'onScroll',
        Category: 'navigation_scroll',
        Action: 'reached_social',
        Label: '<url>',
        Output: 'ga(\'send\',  \'navigation_scroll\', \'reached_social\', \'<url>\');',
    },
    A5: {
        Fire: 'onClick',
        Category: 'navigation',
        Action: 'wf_logo',
        Label: '<url>',
        Output: 'ga(\'send\',  \'navigation\', \'wf_logo\', \'<url>\');',
    },

    B7: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'arts_culture',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'arts_culture\', \'<url>\');',
    },
    B6: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'civic_engagement',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'civic_engagement\', \'<url>\');',
    },
    B9: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'community_development',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'community_development\', \'<url>\');',
    },
    B4: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'education',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'education\', \'<url>\');',
    },
    B5: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'environment',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'environment\', \'<url>\');',
    },
    B2: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'financial_education',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'financial_education\', \'<url>\');',
    },
    B1: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'housing',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'housing\', \'<url>\');',
    },
    B8: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'job_training',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'job_training\', \'<url>\');',
    },
    B3: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'small_business',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'small_business\', \'<url>\');',
    },
    B10: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'social_services',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'social_services\', \'<url>\');',
    },

    B12: {
        Fire: 'onClick',
        Category: 'select_cause',
        Action: 'filter_by_more_org',
        Label: '<url>',
        Output: 'ga(\'send\',  \'select_cause\', \'filter_by_more_org\', \'<url>\');',
    },


    C1: {
        Fire: 'onClick',
        Category: 'search',
        Action: 'organizations',
        Label: '<url>',
        Output: 'ga(\'send\',  \'search\', \'organizations\', \'<url>\');',
    },
    D1: {
        Fire: 'onClick',
        Category: 'see_impact',
        Action: 'organization_story',
        Label: '<story title>',
        Output: 'ga(\'send\',  \'see_impact\', \'organization_story\', \'<story title>\');',
    },
    D2: {
        Fire: 'onClick',
        Category: 'view_more',
        Action: 'organizations',
        Label: '<url>',
        Output: 'ga(\'send\',  \'view_more\', \'organizations\', \'<url>\');',
    },
    E1: {
        Fire: 'onClick',
        Category: 'see_impact',
        Action: 'csr_story',
        Label: '<story title>',
        Output: 'ga(\'send\',  \'see_impact\', \'csr_story\', \'<story title>\');',
    },
    E2: {
        Fire: 'onClick',
        Category: 'read_latest_report',
        Action: 'csr_story',
        Label: '<story title>',
        Output: 'ga(\'send\',  \'read_latest_report\', \'csr_story\', \'<story title>\');',
    },

    E3: {
        Fire: 'onClick',
        Category: 'learn_more',
        Action: 'csr_story',
        Label: '<story title>',
        Output: 'ga(\'send\',  \'learn_more\', \'csr_story\', \'<story title>\');',
    },


    F1: {
        Fire: 'onClick',
        Category: 'social_share',
        Action: '<social platform>',
        Label: '<url>',
        Output: 'ga(\'send\',  \'social_share\', \'<social platform>\', \'<url>\');',
    },
    // F2: {
    //     Fire: 'onClick',
    //     Category: 'view_more',
    //     Action: 'social',
    //     Label: '<url>',
    //     Output: "ga('send',  'view_more', 'social', '<url>');",
    // },
    G1: {
        Fire: 'onClick',
        Category: 'map',
        Action: '<story title>',
        Label: '<url>',
        Output: 'ga(\'send\',  \'map\', \'<story title>\', \'<url>\');',
    },
    H1: {
        Fire: 'onClick',
        Category: 'learn_more',
        Action: 'apply_for_grant',
        Label: '<url>',
        Output: 'ga(\'send\',  \'learn_more\', \'apply_for_grant\', \'<url>\');',
    },
    I1: {
        Fire: 'onClick',
        Category: 'featured_organization',
        Action: '<featured organization title>',
        Label: '<url>',
        Output: 'ga(\'send\',  \'featured_organization\', \'<featured organization title>\', \'<url>\');',
    },
    J1: {
        Fire: 'onClick',
        Category: 'category_label',
        Action: '<category title>',
        Label: '<url>',
        Output: 'ga(\'send\',  \'category_label\', \'<category title>\', \'<url>\');',
    },
};
export default analyticsMap;
